export default "__VITE_ASSET__DtiE5ReN__"